"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatefulComponent = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const getComponent_1 = require("../../getComponent");
const DataObserver = (0, getComponent_1.getComponent)('DataObserver');
const EmptyState = (0, getComponent_1.getComponent)('EmptyState');
const ErrorObserver = (0, getComponent_1.getComponent)('ErrorObserver');
const LoadingState = (0, getComponent_1.getComponent)('LoadingState');
const WaitObserver = (0, getComponent_1.getComponent)('WaitObserver');
// tslint:disable: jsdoc-format
/**
 * # 👨‍🎨 StatefulComponent
 *
 * This is a swiss army knife component. Intended to be used as a single source of UI
 * state management. It shows empty, loading, error or data states based on the given props.
 *
 * ## Usage
```jsx
<StatefulComponent data={data} loading={true} delay={200} timeout={10000}>
 <Text>Content</Text>
</StatefulComponent>
```
 */
const StatefulComponent = (props) => {
    const { component: Component, loadingComponent, emptyComponent, errorComponent, children, 
    // DataObserver
    isLoading, isEmpty, loading, data, 
    // WaitObserver
    delay, timeout, onRetry, onTimeout, 
    // ErrorObserver
    error, checkError } = props, other = tslib_1.__rest(props, ["component", "loadingComponent", "emptyComponent", "errorComponent", "children", "isLoading", "isEmpty", "loading", "data", "delay", "timeout", "onRetry", "onTimeout", "error", "checkError"]);
    const rest = Object.assign({ data }, other);
    const LoadingComponent = loadingComponent;
    const EmptyComponent = emptyComponent;
    return (<ErrorObserver {...{ error, checkError, errorComponent, rest }}>
			<DataObserver {...{ isEmpty, isLoading, loading, data, rest }}>
				{(event) => {
            if (event.loading === true) {
                return react_1.default.createElement(WaitObserver, {
                    delay,
                    onRetry,
                    onTimeout,
                    timeout,
                }, ((p) => <LoadingComponent {...p}/>));
            }
            if (event.empty) {
                return <EmptyComponent />;
            }
            // Render 'component' prop
            if (Component) {
                return react_1.default.createElement(Component, rest);
            }
            // 'children' as a function, 'render prop' pattern
            if (typeof children === 'function') {
                return children(rest);
            }
            // children
            return children;
        }}
			</DataObserver>
		</ErrorObserver>);
};
exports.StatefulComponent = StatefulComponent;
exports.StatefulComponent.displayName = 'StatefulComponent';
exports.StatefulComponent.defaultProps = {
    emptyComponent: EmptyState,
    loadingComponent: LoadingState,
    timeout: 10000,
};
